export default "__VITE_ASSET__b072d894__"